import {Factory} from '../../engine/http/factory/factory';
import {HttpFilter} from '../../engine/http/http-filter';

export class RequestFactory<T> {
  public factory: Factory<T>;
  public filter: HttpFilter;
  public id: string;

  constructor(factory: Factory<T>, filter?: HttpFilter, id?: string) {
    this.factory = factory;
    this.filter = filter;
    this.id = id;
  }
}
